export enum ErrorPageType {
    AUTH_ERROR = 'auth-error',
    SERVER_ERROR = 'server-error',
    NETWORK_ERROR = 'network-error',
    TIMEOUT_ERROR = "timeout-error",
    UNKNOWN_ERROR = "unknown-error",
    SESSION_EXPIRED = "session-expired",
    TIMEOUT_ERROR_REFRESH = "timeout-error-refresh"
}